import { useQuery } from "@apollo/client";
import { GET_MY_PERSON_IS_MANAGER } from "../api/get-my-person-is-manager";

export function useMyPersonIsManager() {
  const { data, loading } = useQuery(GET_MY_PERSON_IS_MANAGER);

  return {
    isManager: data?.getMyPerson.management.isManager ?? false,
    loading,
  };
}
